var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlueTickIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.02205 0.864866C3.74751 0.978181 2.54696 1.54443 1.62386 2.46764C-0.541285 4.63306 -0.541285 8.08515 1.62386 10.2506C3.789 12.416 7.24064 12.416 9.40578 10.2506C10.3427 9.31357 10.8955 8.12862 11.0102 6.81176C11.0454 6.40799 11.0399 6.29668 10.9787 6.17472C10.9124 6.04263 10.8069 5.96799 10.6677 5.9546C10.4814 5.93671 10.3043 6.03183 10.2408 6.18401C10.2219 6.22904 10.2019 6.39236 10.1903 6.59455C10.1514 7.27825 10.0159 7.80105 9.71788 8.41761C9.13864 9.61612 7.96826 10.5724 6.68513 10.8956C6.22686 11.0111 6.09936 11.0252 5.51482 11.0252C4.93028 11.0252 4.80277 11.0111 4.34451 10.8956C2.73645 10.4906 1.38387 9.13783 0.978861 7.52956C0.863449 7.07124 0.849332 6.94372 0.849332 6.3591C0.849332 5.77449 0.863449 5.64697 0.978861 5.18864C1.30204 3.90534 2.25823 2.73481 3.45657 2.1555C4.07306 1.85748 4.59578 1.72196 5.2794 1.68297C5.48156 1.67141 5.64486 1.65137 5.68989 1.63255C5.84204 1.56896 5.93716 1.39191 5.91927 1.20559C5.90588 1.0663 5.83125 0.960829 5.69917 0.894526C5.5815 0.835443 5.42841 0.828739 5.02205 0.864866Z",
    fill: "#2653F1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.42047 5.94007L5.22687 7.74647L9.74288 3.23047",
    stroke: "#2653F1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueTickIcon);
export default __webpack_public_path__ + "static/media/blueTickIcon.0da6e7b5b92d9b73d45f6a3ed1fb1fb0.svg";
export { ForwardRef as ReactComponent };